export enum TrusteeStatus {
  Active, Pending, Expired, Archived, Rejected 
}